import StatusHeader from './StatusHeader';
import { withI18n } from 'react-i18next';

export default withI18n()(StatusHeader);
